import { useState } from 'react';
import { Button, Input, message, Modal, Popconfirm, Select } from 'antd';
import baseuri from '../../methods/baseuri';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import { createStakingProfile } from '../../methods/redux/reducers/staking';

const CreateStakingProfile = () => {
	const dispatch = useAppDispatch();
	const { loading } = useAppSelector((store) => store.staking);
	const { currencies, blockchains } = useAppSelector(
		(store) => store.currencies
	);
	const [visible, setVisible] = useState(false);
	const [state, setState] = useState<any>({});
	const [loadingUserDetails, setLoadingUserDetails] = useState(false);

	const handleInput = (e: any) => {
		const { name, value } = e.target;
		setState({ ...state, [name]: value });
	};

	const getRewardUserDetails = async () => {
		const email = state.rewardUserEmail;
		if (!email) {
			message.warning('Please provide an email address');
			return;
		}

		setLoadingUserDetails(true);

		try {
			const res = await baseuri.get('/admin/users/get-user', {
				params: { email: state.rewardUserEmail },
			});

			if (res.data.data?._id) {
				const rewardUserId = res.data.data._id;
				setState({ ...state, rewardUserId });
				message.success(
					`User found: ${res.data.data.name || res.data.data.email}`
				);
			} else {
				message.warning('No user found with that email address');
			}
		} catch (error: any) {
			console.error('Error fetching user details:', error);

			let errorMessage = 'Failed to fetch user details';
			if (error.response) {
				errorMessage =
					error.response.data?.message ||
					error.response.data?.error?.message ||
					error.response.data?.error ||
					error.response.statusText ||
					`Request failed with status ${error.response.status}`;
			} else if (error.request) {
				errorMessage = 'No response received from server';
			} else {
				errorMessage = error.message || 'Network error occurred';
			}

			message.error(errorMessage);
		} finally {
			setLoadingUserDetails(false);
		}
	};

	const createProfile = async () => {
		if (!state.rewardUserId) {
			message.warning('Please confirm the reward user first');
			return;
		}

		try {
			const resultAction = await dispatch(createStakingProfile(state)).unwrap();

			if (!resultAction?.status) {
				const errorMessage =
					resultAction?.message || 'Failed to create staking profile';
				message.error(errorMessage);
			} else {
				message.success('Staking profile created successfully!');
			}
		} catch (error) {
			message.error('An unexpected error occurred');
		}
	};

	return (
		<div>
			<Modal
				footer={null}
				title="Create Staking Profile"
				visible={visible}
				onCancel={() => setVisible(false)}
			>
				<div>
					<p>Profile Name</p>
					<Input name="name" value={state.name} onChange={handleInput} />
				</div>
				<div>
					<p>Percentage APR</p>
					<Input
						name="apr"
						onChange={handleInput}
						placeholder="Eg: 30"
						addonAfter="%"
					/>
				</div>
				<div>
					<p>Withdrawal Penalty APR</p>
					<Input
						name="withdrawalPenaltyApr"
						placeholder="Eg: 50"
						onChange={handleInput}
						addonAfter="%"
					/>
				</div>
				<div>
					<p>Lock Period</p>
					<Input
						name="periodInDays"
						onChange={handleInput}
						placeholder="Eg: 60"
						addonAfter="days"
					/>
				</div>
				<div>
					<p>Staking Currency</p>
					<Select
						style={{ width: '100%' }}
						onChange={(e) => setState({ ...state, currencyId: e })}
					>
						{currencies.map((currency: any) => (
							<Select.Option key={currency._id} value={currency._id}>
								{currency.symbol}
							</Select.Option>
						))}
					</Select>
				</div>
				<div>
					<p>Staking Form</p>
					<Select
						style={{ width: '100%' }}
						onChange={(e) => setState({ ...state, stakingForm: e })}
					>
						<Select.Option value="blockchain">Blockchain</Select.Option>
						<Select.Option value="local">Local</Select.Option>
					</Select>
				</div>
				<div>
					<p>Mininum Stake Amount</p>
					<Input
						name="minimumStakeAmount"
						onChange={handleInput}
						placeholder="Eg: 1000"
					/>
				</div>
				<div>
					<p>Maximum Total Amount</p>
					<Input
						name="maximumTotalStakeAmount"
						value={state.maximumTotalAmount}
						onChange={handleInput}
						placeholder="Eg: 30000"
					/>
				</div>
				<div>
					<p>Reward User</p>
					<Input
						type="email"
						name="rewardUserEmail"
						onChange={handleInput}
						placeholder="Email"
					/>
					<div>
						<button
							type="button"
							disabled={loadingUserDetails}
							onClick={getRewardUserDetails}
						>
							{loadingUserDetails ? 'confirming...' : 'confirm'}
						</button>
						<div>details</div>
					</div>
				</div>
				<div>
					<p>Blockchain Network</p>
					<Select
						style={{ width: '100%' }}
						onChange={(e) => setState({ ...state, blockchainId: e })}
					>
						{blockchains.map((network: any) => (
							<Select.Option key={network._id} value={network._id}>
								{network.name}
							</Select.Option>
						))}
					</Select>
				</div>
				<div>
					<p>Staking Contract Address</p>
					<Input name="contractAddress" onChange={handleInput} />
				</div>
				<div>
					<p>Profile Details</p>
					<Input.TextArea name="details" onChange={handleInput} />
				</div>
				<div>
					<Popconfirm title="Are you sure?" onConfirm={createProfile}>
						<Button type="primary">Submit</Button>
					</Popconfirm>
				</div>
			</Modal>

			<Button type="primary" loading={loading} onClick={() => setVisible(true)}>
				Create Profile
			</Button>
		</div>
	);
};

export default CreateStakingProfile;
